/**
 * @fileoverview
 * Authentication Interceptor - Adds JWT token to requests
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const token = tokenService.getToken();

  // Skip adding token for public auth endpoints
  const skipUrls = [
    '/auth/login',
    '/auth/admin-login',
    '/auth/forgot-password',
    '/auth/reset-password',
    '/auth/refresh',
  ];
  const shouldSkip = skipUrls.some((url) => req.url.includes(url));

  if (token && !shouldSkip) {
    const headers: Record<string, string> = {
      Authorization: `Bearer ${token}`,
    };

    const clonedReq = req.clone({ setHeaders: headers });
    return next(clonedReq);
  }

  return next(req);
};
